<template>
  <footer class="container-fluid">
    <div class="row" style="border-top: 1px solid #25405d;">
      <div class="col-12" style="display: flex; justify-content: space-between;">
        <div style="width: 100%;">
          <p style="font-size: 30px; font-weight: 500; margin-bottom: 5px;" class="shippori dark-blue">Thank you for your business</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {

}
</script>
